import React from "react";

import SlackMsg from "./SlackMsg";

const initialMessage = [
    {
        msgText:
            "@maja: I want to take more risks and be less shy about putting things out into the world",
        hasEmoji: "🙋‍♀️",
        emojiOrient: "right"
    }
];

const replies = [
    {
        msgText: "@jenny: Can we do this together pls ?",
        hasEmoji: "❤️",
        emojiOrient: "left"
    },
    {
        msgText: "@Anna:  Same! 👏👏👏 "
    },
    {
        msgText: "@maja: I hereby declare the founding of less shy club",
        hasEmoji: "👀",
        emojiOrient: "right"
    },
    {
        msgText: "@jenny: Check your emails / calendars",
        hasEmoji: "💌",
        emojiOrient: "left"
    }
];

const SlackThread = () => (
    <div className="slack-thread">
        <SlackMsg {...initialMessage[0]} hasShadow />
        <div className="slack-thread__divider">
            <span className="slack-thread__divider-text">4 replies</span>
        </div>
        {replies.map((reply, i) => {
            return (
                <SlackMsg
                    key={`msg-${i}`}
                    {...reply}
                    hasShadow
                    className="slack-message--reply"
                />
            );
        })}
    </div>
);

export default SlackThread;



// WEBPACK FOOTER //
// ./src/components/landingPage/SlackThread.jsx